import React, {useEffect, useRef, useState} from "react"
import { useApp } from "../context/appContext"
import toast from "react-hot-toast"
import { formatLocation, formatTestType } from "../utils/lib"
import { saveAs } from 'file-saver'
import { PublicClientApplication } from "@azure/msal-browser"

// Client ID from Google Cloud Console
const CLIENT_ID = '108807900193-fkr28h2isg5qa3u3etc3njn8kioct9jl.apps.googleusercontent.com'


const msalConfig = {
    auth: {
        clientId: '0bc57707-f4a5-4a3a-a0fc-e6c1d9b68842',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'localStorage', // or 'sessionStorage'
        storeAuthStateInCookie: false,
    }
}

const pca = new PublicClientApplication(msalConfig)
await pca.initialize()

const AddToCalendar = ({ bookingConfirmed }) => {
  
    const { form } = useApp()
    const [token, setToken] = useState(null)
    const [loading, setLoading] = useState(false)
    const [addedToCalendar, setAddedToCalendar] = useState(false)
    const [showDropdown, setShowDropdown] = useState(false)
    const dropdownRef = useRef(null);
    const handleOutsideClick = (event) => {
        // Check if the click is outside the dropdown
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setTimeout(() => {
                setShowDropdown(false); // Close dropdown after the event is registered
            }, 1000);  
        }
    };
    useEffect(() => {
        // Add event listener for clicks
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
  // This function will be called when the user clicks on "Add to Calendar"
    const handleAddToGoogleCalendar = () => {
        setLoading(true)
        if(token) {
            addEventToGoogleCalendar(token.access_token)
            return
        }
        // Prompt the user to sign in and grant access
        window.google.accounts.oauth2.initTokenClient({
            client_id: CLIENT_ID,
            scope: "https://www.googleapis.com/auth/calendar.events",
            callback: (tokenResponse) => {
                setToken(tokenResponse)
                // Use the token to make requests to the Google Calendar API
                addEventToGoogleCalendar(tokenResponse.access_token)
            },
            error_callback: (err) => {
                setLoading(false)
            }
        }).requestAccessToken()
    }

    const addEventToGoogleCalendar = (accessToken) => {
        if(addedToCalendar) {
            toast.error("Event already added to Google Calendar!")
            setLoading(false)
            return
        }
        const event = {
            summary: `Eye Test at The Optical Superstore`,
            location: `${formatLocation(form?.location)}`,
            description: `${formatTestType(form?.testId)} at Optical Super Store.`,
            start: {
              dateTime: `${form?.time?.appointmentDate}T${form?.time?.startTime}`,
              timeZone: "Australia/Sydney"
            },
            end: {
              dateTime: `${form?.time?.appointmentDate}T${form?.time?.endTime}`,
              timeZone: "Australia/Sydney"
            },
            reminders: {
              useDefault: false,
              overrides: [
                { method: 'email', minutes: 24 * 60 },
                { method: 'popup', minutes: 10 }
              ]
            }
        }


        fetch('https://www.googleapis.com/calendar/v3/calendars/primary/events', {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
            body: JSON.stringify(event),
        }).then((response) => response.json()).then((data) => {
            toast.success("Event added to Google Calendar!")
            setAddedToCalendar(true)
        }).catch((error) => {
            console.error('Error creating event:', error)
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleAddToOutlookCalendar = async () => {
        try {
            setLoading(true)
    
            // Initialize PCA if needed
            if (!pca) pca.initialize()
    
            // Get the account (logged-in user) from MSAL
            const accounts = pca.getAllAccounts()
            let accessToken
    
            if (accounts.length > 0) {
                // If an account exists, try to silently acquire the token
                const silentRequest = {
                    scopes: ["Calendars.ReadWrite"],
                    account: accounts[0],  // Use the first account (usually the only one)
                }
    
                try {
                    const tokenResponse = await pca.acquireTokenSilent(silentRequest)
                    accessToken = tokenResponse.accessToken
                } catch (silentError) {
                    // If silent token acquisition fails, fallback to loginPopup
                    console.log('Silent token acquisition failed, showing login popup', silentError)
                    const loginResponse = await pca.loginPopup({
                        scopes: ["Calendars.ReadWrite"]
                    })
                    accessToken = loginResponse.accessToken
                }
            } else {
                // No account exists, prompt the user to login
                const loginResponse = await pca.loginPopup({
                    scopes: ["Calendars.ReadWrite"]
                })
                accessToken = loginResponse.accessToken
            }
    
            // Now proceed with creating the event
            addEventToOutlookCalendar(accessToken)
    
        } catch (error) {
            console.error('Error logging into Microsoft Outlook Calendar:', error)
        } finally {
            setLoading(false)
        }
    }

    const addEventToOutlookCalendar = async (accessToken) => {
        const event = {
            subject: 'Eye Test at The Optical Superstore',
            body: {
                contentType: 'HTML',
                content: `${formatTestType(form?.testId)} at Optical Super Store.`
            },
            start: {
                dateTime: `${form?.time?.appointmentDate}T${form?.time?.startTime}`,
                timeZone: "Australia/Sydney"
            },
            end: {
                dateTime: `${form?.time?.appointmentDate}T${form?.time?.endTime}`,
                timeZone: "Australia/Sydney"
            },
            location: {
                displayName: `${formatLocation(form?.location)}`
            },
            attendees: [
                {
                    emailAddress: {
                        address: form?.bookingForm?.personEmail,
                        name: `${form?.bookingForm?.firstName} ${form?.bookingForm?.lastName}`
                    },
                    type: "required"
                }
            ]
        }
    
        try {
            const response = await fetch("https://graph.microsoft.com/v1.0/me/events", {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(event)
            })
    
            if (response.ok) {
                toast.success("Event added to Microsoft Outlook Calendar!")
            } else {
                throw new Error('Failed to add event')
            }
        } catch (error) {
            console.error('Error creating event in Outlook Calendar:', error)
            toast.error("Failed to add event to Microsoft Outlook Calendar!")
        } finally {
            setLoading(false)
        }
    }

    const handleAddToAppleCalendar = () => {
        const event = {
            uid: Math.random().toString(36).substring(2,7), // Unique ID for the event
            start: [
                parseInt(form?.time?.appointmentDate.split('-')[0]), 
                parseInt(form?.time?.appointmentDate.split('-')[1]), 
                parseInt(form?.time?.appointmentDate.split('-')[2]), 
                parseInt(form?.time?.startTime.split(':')[0]), 
                parseInt(form?.time?.startTime.split(':')[1])
            ],
            end: [
                parseInt(form?.time?.appointmentDate.split('-')[0]), 
                parseInt(form?.time?.appointmentDate.split('-')[1]), 
                parseInt(form?.time?.appointmentDate.split('-')[2]), 
                parseInt(form?.time?.endTime.split(':')[0]), 
                parseInt(form?.time?.endTime.split(':')[1])
            ],
            title: `Eye Test at The Optical Superstore`,
            // location: `${formatLocation(form?.location)}`,
            location: `${formatLocation(form?.location).replace(/,/g, '')}`,
            // description: `${formatTestType(form?.testId)} at Optical Super Store.\r\nEmail: marketing@opticalsuperstore.com.au\r\nMap: https://maps.google.com/?q=${form?.location?.PIAB__Coordinates__c?.latitude},${form?.location?.PIAB__Coordinates__c?.longitude}`,
            description: `${formatTestType(form?.testId)} at Optical Super Store.\\nEmail: marketing@opticalsuperstore.com.au\\nMap: https://maps.google.com/?q=${form?.location?.PIAB__Coordinates__c?.latitude},${form?.location?.PIAB__Coordinates__c?.longitude}`,
            status: 'CONFIRMED',
            organizer: { name: 'Optical Super Store', email: 'contact@opticalsuperstore.com' },
            attendees: [
                { name: `${form?.bookingForm?.firstName} ${form?.bookingForm?.lastName}`, email: form?.bookingForm?.personEmail }
            ],
            alarms: [
                { action: 'email', trigger: { hours: 24, minutes: 0, before: true } }, // Reminder email 24 hours before
                { action: 'display', trigger: { hours: 0, minutes: 10, before: true } } // Popup 10 minutes before
            ],
            url: 'https://www.opticalsuperstore.com.au',
            geo: `${form?.location?.PIAB__Coordinates__c?.latitude};${form?.location?.PIAB__Coordinates__c?.longitude}`
        }
    
        const icsContent = generateICS(event)
    
        // Trigger the download
        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' })
        saveAs(blob, 'appointment.ics')
    
        toast.success('Event added to Apple Calendar!')
    }
    
    const generateICS = (event) => {
        // console.log("Event", event);
        // return;
        // Format date to the correct UTC format (YYYYMMDDTHHMMSSZ)
        // const formatDate = (dateArray) => {
        //     const [year, month, day, hour, minute] = dateArray;
        //     return `${year}${pad(month)}${pad(day)}T${pad(hour)}${pad(minute)}00Z`
        // }
        //
        // const pad = (number) => number < 10 ? `0${number}` : number

        const pad = (value) => String(value).padStart(2, '0');

        const formatDateToUTC = (dateArray) => {
            const [year, month, day, hour, minute] = dateArray;

            // Create a Date object in Australian Eastern Time (AEST/AEDT)
            const localDate = new Date(Date.UTC(year, month - 1, day, hour, minute));

            // Adjust for Australian Eastern Time offset
            const timeZoneOffset = 10 * 60 * 60 * 1000; // AEST is UTC+10 hours
            localDate.setTime(localDate.getTime() - timeZoneOffset);

            // Convert the date to UTC parts
            const utcYear = localDate.getUTCFullYear();
            const utcMonth = pad(localDate.getUTCMonth() + 1);
            const utcDay = pad(localDate.getUTCDate());
            const utcHour = pad(localDate.getUTCHours());
            const utcMinute = pad(localDate.getUTCMinutes());

            // Format as YYYYMMDDTHHMMSSZ
            return `${utcYear}${utcMonth}${utcDay}T${utcHour}${utcMinute}00Z`;
        };

        // Start and end times
        const dtStart = formatDateToUTC(event.start)
        const dtEnd = formatDateToUTC(event.end)
        return [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'CALSCALE:GREGORIAN',
            'PRODID:-//YourApp//EN',
            'METHOD:PUBLISH',
            'X-PUBLISHED-TTL:PT1H',
            'BEGIN:VEVENT',
            `UID:${event.uid}`, // Unique ID
            // `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')}Z`, // Creation timestamp
            `DTSTART:${dtStart}`,
            `DTEND:${dtEnd}`,
            `SUMMARY:${event.title}`,
            `DESCRIPTION:${event.description}`,
            `LOCATION:${event.location}`,
            `STATUS:${event.status}`,
            `URL:${event.url}`, // Event URL
            `GEO:${event.geo}`, // Optional geolocation
            `ORGANIZER;CN=${event.organizer.name}:mailto:${event.organizer.email}`,
            event.attendees.map(attendee => 
                `ATTENDEE;RSVP=TRUE;ROLE=REQ-PARTICIPANT;CN=${attendee.name}:mailto:${attendee.email}`
            ).join('\r\n'),
            'BEGIN:VALARM',
            'TRIGGER:-PT24H',
            'ACTION:EMAIL',
            'DESCRIPTION:Reminder',
            'END:VALARM',
            'BEGIN:VALARM',
            'TRIGGER:-PT10M',
            'ACTION:DISPLAY',
            'DESCRIPTION:Reminder',
            'END:VALARM',
            'END:VEVENT',
            'END:VCALENDAR'
        ].join('\r\n')
    }


    const handleAddToYahooCalendar = () => {
        const eventTitle = encodeURIComponent('Eye Test at The Optical Superstore');
        const eventDescription = encodeURIComponent(`${formatTestType(form?.testId)} at Optical Super Store.`);
        const eventLocation = encodeURIComponent(formatLocation(form?.location));
        const startDate = encodeURIComponent(`${form?.time?.appointmentDate.replace(/-/g, '')}T${form?.time?.startTime.replace(':', '')}00Z`);
        const endDate = encodeURIComponent(`${form?.time?.appointmentDate.replace(/-/g, '')}T${form?.time?.endTime.replace(':', '')}00Z`);

        const yahooCalendarUrl = `https://calendar.yahoo.com/?v=60&title=${eventTitle}&desc=${eventDescription}&in_loc=${eventLocation}&st=${startDate}&et=${endDate}`;

        window.open(yahooCalendarUrl, '_blank');
    }

    
    const handleCalendarOptionClick = (calendarType) => {
        console.log("Event calendarType", calendarType);
        switch (calendarType) {
            case "google":
                handleAddToGoogleCalendar()
                break
            case "outlook":
                handleAddToOutlookCalendar()
                break
            case "apple":
                handleAddToAppleCalendar()                
                break
            case "yahoo":
                handleAddToYahooCalendar()                
                break
            default:
                setLoading(false)
        }
    }

    useEffect(() => {
        const script = document.createElement('script')
        script.src = "https://accounts.google.com/gsi/client"
        script.async = true
        script.defer = true
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
       // <div className="calendar-container full-btn" >
        <>
            <button className="calendar-btn full-btn add-to-calendar" disabled={loading || !bookingConfirmed} ref={dropdownRef} onClick={() => setShowDropdown(!showDropdown)}>
                {loading ? (
                    <div className="loader-container">
                        <div className="loader-btn-calendar"></div>
                    </div>
                ) : "Add to Calendar"}
            </button>
       
            {showDropdown && (
                <div className="calendar-dropdown">
                    <p className="calendar-option" onClick={() => handleCalendarOptionClick('apple')}>Apple Calendar</p>
                    <p className="calendar-option" onClick={() => handleCalendarOptionClick('google')}>Google Calendar</p>
                    <p className="calendar-option" onClick={() => handleCalendarOptionClick('outlook')}>Microsoft Outlook</p>
                    <p className="calendar-option" onClick={() => handleCalendarOptionClick('yahoo')}>Yahoo</p>
                </div>
            )}
        </>

        // </div>
    )
}

export default AddToCalendar